{
  "elementLibrary": {
    "productName": "Product title",
    "cargaHoraria": "Course hours",
    "instrutor": "Instructor name",
    "studentName": "Member name",
    "issuedAt": "Issue date",
    "completionDate": "Course completion date",
    "hash": "Hash",
    "media": "Student average",
    "documento": "Member ID document",
    "certText": "Certification text",
    "concludeText": "Completion text",
    "text": "Free text"
  },
  "dateFormats": {
    "dateTime": "MM/dd/yyyy h:mm a",
    "date": "MM/dd/yyyy"
  },
  "list": {
    "title": "Certificates",
    "subtitle": "Manage your certificates and issuances",
    "tabs": {
      "created": "Created certificates",
      "history": "Issuance history"
    },
    "deleteConfirm": {
      "title": "Delete certificate",
      "description": "Are you sure? Templates with issuances can't be deleted.",
      "confirm": "Delete"
    },
    "revokeConfirm": {
      "title": "Revoke certificate",
      "description": "The certificate will no longer be valid in public verification.",
      "confirm": "Revoke"
    },
    "toasts": {
      "deleted": "Certificate deleted",
      "deleteError": "Error deleting",
      "revoked": "Certificate revoked",
      "revokeError": "Error revoking",
      "linkCopied": "Link copied",
      "copyError": "Couldn't copy"
    },
    "created": {
      "searchPlaceholder": "Search by title or code",
      "create": "Create certificate",
      "columns": {
        "code": "CODE",
        "certificate": "CERTIFICATE",
        "products": "PRODUCTS",
        "mec": "MEC",
        "createdAt": "CREATED ON",
        "issued": "ISSUED"
      },
      "actions": {
        "edit": "Edit certificate",
        "delete": "Delete"
      },
      "empty": "No certificates created"
    },
    "history": {
      "searchPlaceholder": "Search by member, email or code",
      "issue": "Issue certificate",
      "columns": {
        "id": "ID",
        "member": "MEMBER",
        "product": "PRODUCT",
        "date": "DATE",
        "certificate": "CERTIFICATE"
      },
      "revoked": "Revoked",
      "actions": {
        "view": "View certificate",
        "goToProfile": "Go to member profile",
        "copyLink": "Copy link",
        "revoke": "Revoke certificate"
      },
      "empty": "No issuances yet"
    },
    "pagination": {
      "summary": "Page {{page}} of {{totalPages}} ({{total}})",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "editorPage": {
    "toasts": {
      "saved": "Settings saved",
      "saveError": "Error saving"
    },
    "back": "Back",
    "title": "Certificate editor",
    "untitled": "Certificate",
    "save": "Save settings",
    "fields": {
      "title": "Title",
      "workload": "Course hours",
      "workloadPlaceholder": "e.g. 40 hours",
      "mec": "MEC seal",
      "allowReissue": "Allow reissue"
    },
    "products": {
      "title": "Linked content ({{count}})",
      "searchPlaceholder": "Search content..."
    }
  },
  "createDialog": {
    "validation": {
      "nameMin": "Title must be at least 2 characters"
    },
    "yes": "Yes",
    "no": "No",
    "toasts": {
      "created": "Certificate created",
      "createError": "Error creating certificate"
    },
    "title": "Create certificate",
    "description": "Set up the certificate. The editor opens next.",
    "nameLabel": "Certificate title *",
    "namePlaceholder": "E.g. Certificate of Completion",
    "mecQuestion": "Will the certificate have the MEC seal?",
    "reissueQuestion": "Allow the certificate to be reissued?",
    "productsLabel": "Select content for this certificate",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_zero": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "searchPlaceholder": "Search content...",
    "noProducts": "No content found",
    "cancel": "Cancel",
    "submitting": "Creating...",
    "submit": "Create certificate"
  },
  "issueDialog": {
    "validation": {
      "selectProduct": "Select a content item",
      "memberRequired": "Enter the member (ID, name or email)"
    },
    "toasts": {
      "issued": "Certificate issued",
      "issueError": "Error issuing certificate"
    },
    "title": "Issue certificate",
    "description": "Choose the content and enter the member.",
    "memberLabel": "Member (ID, name or email) *",
    "memberPlaceholder": "E.g. maria@email.com",
    "productLabel": "Content *",
    "searchPlaceholder": "Search content...",
    "noProducts": "No content found",
    "cancel": "Cancel",
    "submitting": "Issuing...",
    "submit": "Issue certificate"
  },
  "userTab": {
    "title": "Certificates ({{count}})",
    "revoke": "Revoke",
    "empty": "This member doesn't have any certificates yet"
  },
  "visualEditor": {
    "toasts": {
      "uploadSuccess": "File uploaded",
      "uploadError": "Error uploading file"
    },
    "panel": {
      "elements": "Elements",
      "others": "Others",
      "image": "Image"
    },
    "toolbar": {
      "background": "Background",
      "backgroundColor": "Background color",
      "backgroundImage": "Background image",
      "remove": "Remove",
      "uploadFont": "Upload font",
      "font": "Font"
    },
    "canvasHint": "Drag to position. Click to select and use the green handles to resize.",
    "inspector": {
      "image": "Image",
      "text": "Text",
      "textLabel": "Text",
      "font": "Font",
      "size": "Size",
      "color": "Color",
      "weight": "Weight",
      "weights": {
        "normal": "Normal",
        "semibold": "Semi-bold",
        "bold": "Bold",
        "black": "Black"
      },
      "alignment": "Alignment",
      "align": {
        "left": "Align left",
        "center": "Align center",
        "right": "Align right"
      },
      "width": "Width",
      "height": "Height",
      "auto": "auto",
      "replaceImage": "Replace image",
      "uploadImage": "Upload image",
      "empty": "Select an element on the canvas to edit it."
    }
  },
  "elementDefaults": {
    "certText": "This certifies that the student has successfully completed the content.",
    "concludeText": "Successfully completed on the platform.",
    "text": "New text"
  }
}
